module.exports = __webpack_public_path__ + "media/images/tango_logo-114a696762dab08d62a90adc22a5c2d4.png";